"use strict";

angular.module("imagetrend.components").directive("hlpVerifyPassword", [
    "$http",
    "$q",
    "$rootScope",
    "$stateParams",
    "Format",
    function(
        $http,
        $q,
        $rootScope,
        $stateParams,
        Format
    ) {
        return {
            restrict: "AE",
            scope: {
                ngModel: "=",
                question: "=?",

                //attributes
                name: "@?",
                id: "@?",
                classes: "@?",
                type: "@?",

                //disabled
                isDisabled: "=?",

                //required
                isRequired: "=?",
                showRequired: "=?",
                requiredText: "@?",

                //label
                showLabel: "@?",
                topLabel: "=?",
                label: "@?",
                title: "@?",

                //instructions
                instructions: "@?",
                showColon: "=?",

                pdf: "=?"
            },
            replace: true,
            transclude: true,
            templateUrl: "templates/verify-password/verify-password.html",
            link: function(scope, elem, attrs, ctrl) {
                //attributes
                if (!attrs.name) {
                    attrs.name = "input";
                }
                if (!attrs.id) {
                    attrs.id = attrs.name;
                }
                if (!attrs.type) {
                    attrs.type = "password";
                }

                //label
                if (!attrs.label) {
                    attrs.label = Format.label(attrs.name);
                }
                if (!attrs.showLabel) {
                    attrs.showLabel = attrs.label.length > 0;
                } else {
                    if (attrs.showLabel == "true") {
                        attrs.showLabel = true;
                    } else {
                        attrs.showLabel = false;
                    }
                }
                if (!attrs.title) {
                    attrs.title = attrs.label;
                }
                if (!attrs.topLabel) {
                    attrs.topLabel = false;
                } else {
                    if (attrs.topLabel == true || attrs.topLabel == "true") {
                        attrs.topLabel = true;
                    } else {
                        attrs.topLabel = false;
                    }
                }
                if (!attrs.showColon) {
                    attrs.showColon = true;
                } else {
                    if (attrs.showColon == true || attrs.showColon == "true") {
                        attrs.showColon = true;
                    } else {
                        attrs.showColon = false;
                    }
                }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                if (!attrs.requiredText) {
                    scope.requiredText = "Please enter your password";
                }

                scope.$evalAsync(function() {
                    scope.innerForm.innerForm.pass.$asyncValidators.invalid = function(
                        modelValue,
                        viewValue
                    ) {
                        var d = $q.defer();
                        if (
                            scope.type == "password" &&
                            (typeof modelValue !== "undefined" ||
                                typeof viewValue !== "undefined")
                        ) {
                            $http
                                .post(apiLocation + "/api/account/validate", {
                                    password: modelValue || viewValue,
                                    user_name: $rootScope.userAccount.user_name,
                                    responseID: $stateParams.responseID
                                })
                                .then(function(response) {
                                    // since this is an asyncronous function, there's a chance the promises will resolve in a different order. Only the one that matches the actual value of pass counts
                                    if (response.data && response.data.valid) {
                                        scope.ngModel.user_id =
                                            $rootScope.userAccount.id;
                                        scope.ngModel.date = new Date();
                                        scope.ngModel.user_name =
                                            $rootScope.userAccount.user_name;
                                        scope.ngModel.first_name =
                                            $rootScope.userAccount.first_name;
                                        scope.ngModel.last_name =
                                            $rootScope.userAccount.last_name;
                                        scope.ngModel.display_name = $rootScope.userAccount.first_name + ' ' + $rootScope.userAccount.last_name;
                                        scope.question.answer.invalid = false;
                                    } else if (
                                        typeof scope.ngModel.pass !==
                                        "undefined"
                                    ) {
                                        // for some reason not required is sending an undefined password a second time around, so skip if password is undefined
                                        scope.ngModel.user_id = null;
                                        scope.ngModel.date = null;
                                        scope.ngModel.user_name = null;
                                        scope.question.answer.invalid = true;
                                    }
                                    return scope.question.answer.invalid ? d.reject(false) : d.resolve(true);
                                })
                                .catch(function(response) {
                                    d.reject(response.data);
                                });
                        } else {
                            // placeholder
                            return $q.when();
                        }

                        return d.promise;
                    };
                });
            },
            controller: [
                "$scope",
                "$rootScope",
                "$timeout",
                function(
                    $scope,
                    $rootScope,
                    $timeout
                ) {
                    $scope.submitted = false;
                    if (typeof $scope.ngModel == "undefined") {
                        $scope.ngModel = {};
                    }
                    $scope.showUsername =
                        typeof $scope.ngModel.user_name !== "undefined" &&
                        $scope.ngModel.user_name !== null
                            ? $scope.ngModel.user_name
                            : $rootScope.userAccount.user_name;

                    $scope.validate = function() {
                        // $scope.submitted = false;
                        if ($scope.type == "password") {
                            if ($scope.ngModel.user_id) {
                                // successfully signed once
                                if (
                                    $scope.isRequired &&
                                    $scope.innerForm.innerForm.pass
                                        .$viewValue === "" &&
                                    $scope.innerForm.innerForm.pass.$dirty
                                ) {
                                    // they cleared it out
                                    $scope.question.answer.invalid = true;
                                    $scope.innerForm.innerForm.pass.$setValidity(
                                        "required",
                                        false
                                    );
                                    $scope.ngModel.user_id = null;
                                    $scope.ngModel.date = null;
                                    $scope.ngModel.user_name = null;
                                } else {
                                    $scope.question.answer.invalid = false;
                                    $scope.innerForm.innerForm.pass.$setValidity(
                                        "required",
                                        true
                                    );
                                }
                            } else if (!$scope.isRequired) {
                                // all values are wiped out anyway so we are just going to let them pass
                                $scope.question.answer.invalid = false;
                                $scope.innerForm.innerForm.pass.$setValidity(
                                    "invalid",
                                    true
                                );
                            } else {
                                $scope.question.answer.invalid = true;
                            }
                        }
                    };
                    var timer = $timeout($scope.validate(), 0);

                    var cleanupSubmitHandler = $scope.$on(
                        "form:submit",
                        function() {
                            $scope.validate();
                            $scope.submitted = true;
                        }
                    );

                    $scope.$on("$destroy", function() {
                        $timeout.cancel(timer);
                        cleanupSubmitHandler();
                    });
                }
            ]
        };
    }
]);
